<template>
    <div>
      <el-card class="main_box-card">
        <div slot="header" class="clearfix">
          <h2>关于举办“2023年（第十一届）中国水利信息化技术论坛”的通知</h2>
          <span style="font-size: 14px;">来源：信息学部 &nbsp;&nbsp;&nbsp;&nbsp;发布时间：2023-03-15</span>
        </div>
        <div class="newsBox">
          <el-container  style="border: 1px solid #eee;margin-left: 10px;">
            <iframe src="/infopdf/info2.pdf"  frameborder="0" width="100%" height="600px" ></iframe>
          </el-container>
        </div>
      </el-card>
    </div>
  </template>
  
  <script>
  export default {
    data () {
	   return {
	   }
	 },
  }
  </script>
  
  <style lang="less" scoped>
  .newsBox{
    text-align: start;
    margin: 8px;
    
  }
  </style>